<template>
  <MainNavbar class="style-three" />
  <PageTitle
    pageTitle="Franchise"
    mainTitle="Guac & Grill"
    subTitle="Halal Mexican Food"
  />
  <FranchiseHero />
  <FranchiseMenu />
  <FranchiseBenefits />
  <FranchiseRequirements />
  <FranchiseProcess />
  <FranchiseInvestment />
  <FranchiseContact />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import PageTitle from "../components/Common/PageTitle.vue";
import FranchiseHero from "../components/Franchise/FranchiseHero.vue";
import FranchiseMenu from "../components/Franchise/FranchiseMenu.vue";
import FranchiseBenefits from "../components/Franchise/FranchiseBenefits.vue";
import FranchiseRequirements from "../components/Franchise/FranchiseRequirements.vue";
import FranchiseProcess from "../components/Franchise/FranchiseProcess.vue";
import FranchiseInvestment from "../components/Franchise/FranchiseInvestment.vue";
import FranchiseContact from "../components/Franchise/FranchiseContact.vue";

export default defineComponent({
  name: "HomePage",
  components: {
    MainNavbar,
    PageTitle,
    FranchiseHero,
    FranchiseMenu,
    FranchiseBenefits,
    FranchiseRequirements,
    FranchiseProcess,
    FranchiseInvestment,
    FranchiseContact,
  },
});
</script>

<style>
/* Global dark theme overrides - not scoped */
body {
  background-color: #1a1a1a !important;
}

.feature-wrap.style-three {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 50%, #1f1f1f 100%) !important;
}

.feature-wrap.style-two {
  background: linear-gradient(135deg, #1f2937 0%, #374151 100%) !important;
}

.bg_secondary {
  background: linear-gradient(135deg, #1f2937 0%, #374151 100%) !important;
}

.franchise-investment {
  background: linear-gradient(135deg, #1f2937 0%, #374151 100%) !important;
}

.promo-wrap {
  background: linear-gradient(135deg, #1f2937 0%, #374151 100%) !important;
}

.combo-wrap {
  background: linear-gradient(135deg, #1f2937 0%, #374151 100%) !important;
}

/* Force text colors */
.feature-wrap h2, .feature-wrap h3, .feature-wrap h4, .feature-wrap h5, .feature-wrap h6 {
  color: #ffffff !important;
}

.feature-wrap p, .feature-wrap li {
  color: #d1d5db !important;
}
</style>
